// Centralized query key factory for React Query cache consistency
// Using factory pattern ensures type safety and consistent cache key generation

export const queryKeys = {
  programs: {
    all: ['programs'] as const,
    list: (type: string, locale: string) => ['programs', 'list', type, locale] as const,
    detail: (slug: string, locale: string) => ['programs', 'detail', slug, locale] as const,
  },
  programUnits: {
    all: ['programUnits'] as const,
    detail: (slug: string, locale: string) => ['programUnits', 'detail', slug, locale] as const,
  },
  bookmarks: {
    all: ['bookmarks'] as const,
    byUser: (userId: string) => ['bookmarks', 'user', userId] as const,
  },
  appCopy: {
    all: ['appCopy'] as const,
    main: (locale: string) => ['appCopy', 'main', locale] as const,
    hub: (locale: string) => ['appCopy', 'hub', locale] as const,
  },
  resources: {
    all: ['resources'] as const,
    detail: (code: string, locale: string) => ['resources', 'detail', code, locale] as const,
  },
  user: {
    current: ['user', 'current'] as const,
    products: ['user', 'products'] as const,
    apps: ['user', 'apps'] as const,
  },
  kaiya: {
    sessions: ['kaiya', 'sessions'] as const,
    session: (id: string) => ['kaiya', 'session', id] as const,
    prompts: (locale: string) => ['kaiya', 'prompts', locale] as const,
    tierLimit: ['kaiya', 'tierLimit'] as const,
    memory: ['kaiya', 'memory'] as const,
    taggableProjects: ['kaiya', 'taggableProjects'] as const,
  },
  productDisplay: {
    all: ['productDisplay'] as const,
    config: (locale: string) => ['productDisplay', 'config', locale] as const,
  },
  productDrawer: {
    all: ['productDrawer'] as const,
    forUser: (userId: string, workspaceId: string) => ['productDrawer', userId, workspaceId] as const,
  },
  workspaces: {
    all: ['workspaces'] as const,
    forUser: (userId: string) => ['workspaces', userId] as const,
  },
}
